import type { RandomSource } from './random.ts';
import { randomIntInRange } from './random.ts';
import type { RoundConfig } from './rules.ts';

/** Server/host-generated target duration for a round, rounded to the nearest 10ms. */
export function generateTargetMs(random: RandomSource, config: RoundConfig): number {
  const raw = randomIntInRange(random, config.minTargetMs, config.maxTargetMs);
  return Math.round(raw / 10) * 10;
}

/** Randomised hidden delay before the clock starts, so players cannot count from a fixed cue. */
export function generatePrepareDelayMs(random: RandomSource, config: RoundConfig): number {
  return randomIntInRange(random, config.minPrepareDelayMs, config.maxPrepareDelayMs);
}
